import React, { useMemo, useState } from 'react';
import { Box, Stack } from '@mui/material';
import InvoiceCategoryTabs from '../../../../../components/Billing/Invoice/InvoiceCategoryTabs';
import AdvanceRefundLogs from './Advance_Refund_logs';
import ProceedAdvance from './Proceed_Advance';
import { useTranslation } from 'react-i18next';

type AdvanceRefundTabKey = 'REFUND_ADVANCES' | 'REFUND_LOGS';



const AdvanceRefundDetails: React.FC = () => {
  const { t: tBilling } = useTranslation('billing_config');
  const [activeTab, setActiveTab] = useState<AdvanceRefundTabKey>('REFUND_ADVANCES');


  const categories = useMemo(
    () => [
      { label: tBilling('RefundDetails.tabs.refundAdvances', 'Refund Advances'), name:'REFUND_ADVANCES'},
      { label: tBilling('RefundDetails.tabs.refundLogs', 'Refund Logs'), name:'REFUND_LOGS'},
    ],
    [tBilling]
  );
  return (
    <Box sx={{ px: 3, py: 2 }} data-testid="advance-refund-details-container">
      <Stack direction="row" justifyContent="flex-start" sx={{ mb: 2 }} data-testid="advance-refund-tabs-section">
        <InvoiceCategoryTabs
          activeCategory={activeTab}
          categories={categories}
          onCategoryChange={(cat) => setActiveTab(cat.name as AdvanceRefundTabKey)}
        />
      </Stack>

      {activeTab === 'REFUND_ADVANCES' && (
        <ProceedAdvance />
      )}
      {activeTab === 'REFUND_LOGS' && (
        <AdvanceRefundLogs />
      )}
    </Box>
  );
};

export default AdvanceRefundDetails;

